"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seriesNonceManagerContractAddresses = exports.SERIES_NONCE_MANAGER_ABI = void 0;
const tslib_1 = require("tslib");
const limit_order_protocol_model_1 = require("./model/limit-order-protocol.model");
const SeriesNonceManagerABI_json_1 = tslib_1.__importDefault(require("./abi/SeriesNonceManagerABI.json"));
exports.SERIES_NONCE_MANAGER_ABI = SeriesNonceManagerABI_json_1.default;
exports.seriesNonceManagerContractAddresses = {
    [limit_order_protocol_model_1.ChainId.etherumMainnet]: '0x303389f541ff2d620e42832f180a08e767b28e10',
    [limit_order_protocol_model_1.ChainId.binanceMainnet]: '0x58ce0e6ef670c9a05622f4188faa03a9e12ee2e4',
    [limit_order_protocol_model_1.ChainId.polygonMainnet]: '0xa5eb255ef45dfb48b5d133d08833def69871691d',
    [limit_order_protocol_model_1.ChainId.optimismMainnet]: '0x32d12a25f539e341089050e2d26794f041fc9df8',
    [limit_order_protocol_model_1.ChainId.arbitrumMainnet]: '0xd7936052d1e096d48c81ef3918f9fd6384108480',
    [limit_order_protocol_model_1.ChainId.gnosisMainnet]: '0x11431a89893025d2a48dca4eddc396f8c8117187',
    [limit_order_protocol_model_1.ChainId.avalancheMainnet]: '0x2ec255797fef7669fa243509b7a599121148ffba',
    [limit_order_protocol_model_1.ChainId.auroraMainnet]: '0x7f069df72b7a39bce9806e3afaf579e54d8cf2b9',
    [limit_order_protocol_model_1.ChainId.fantomMainnet]: '0x7871769b3816b23dB12E83a482aAc35F1FD35D4B',
    [limit_order_protocol_model_1.ChainId.klaytnMainnet]: '0x7871769b3816b23dB12E83a482aAc35F1FD35D4B',
};
//# sourceMappingURL=series-nonce-manager.const.js.map